export default {
    setSelectedPath(state, payload = {}) {
        state.selectedPath = payload;
    },
    setPermissionOfSelectedBin(state, payload) {
        state.binPermission = payload;
    }
};